<template>
  <div>
   <table class="list-box" >
          <colgroup>
            <col width="500" />
            <col width="300" />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th class="first" colSpan="3">
                <router-link :to="{ path: `/${item.merchantCode}` }">
                  <i class="icons icon-shop"></i>
                  {{item.merchantName}}
                </router-link>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="jifen-info">
              <td class="first">
                <template  v-if="item.productVOs.length > 0">
                  <router-link :to="{ path: `/product/${item.merchantCode}/${v.productCode}` }" v-if="i < 4" v-for="(v,i) in item.productVOs" :key="i">
                    <img v-if="v.imageUrl" :src="v.imageUrl" :alt="v.productCode"/>
                    <img v-else src='../assets/no-picture.png' :title="v.productCode"/>
                  </router-link>
                </template>
                <template v-else>
                  暂无礼品可兑换
                </template>
              </td>
              <td><IconJifen size="gray" :points="item.points" /></td>
              <td class="list-set" v-if="!$route.params.id">
                <router-link :to="{ path: `/${item.merchantCode}` }">礼品兑换</router-link>
                <router-link :to="{ path: `/my/jifen/${item.merchantCode}` }">积分明细</router-link>
              </td>
              <td class="list-set"v-else>
                <router-link :to="{ path: `/${item.merchantCode}` }">去兑换</router-link>
              </td>
            </tr>
          </tbody>
      </table>
  </div>
</template>
<script>
import IconJifen from "./icon-jifen";
export default {
  name: "NoList",
  components: {
    IconJifen
  },
  props: {
    item: {}
  }
};
</script>
<style scoped>
.icon-shop {
  background-position: -35px 0px;
  display: inline-block;
  width: 15px;
  height: 14px;
  cursor: pointer;
  vertical-align: -3px;
  margin-right: 2px;
}
.jifen-info {
  vertical-align: middle;
}
.jifen-info .first {
  text-align: left;
  padding: 10px 16px;
  color: #999;
}
.list-set a {
  display: block;
  line-height: 26px;
}
</style>
